import { render, staticRenderFns } from "./DetallePago.vue?vue&type=template&id=6b89beaa&scoped=true"
import script from "./DetallePago.vue?vue&type=script&lang=js"
export * from "./DetallePago.vue?vue&type=script&lang=js"
import style0 from "./DetallePago.vue?vue&type=style&index=0&id=6b89beaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89beaa",
  null
  
)

export default component.exports